// src/utils/registerServiceWorker.js
//
// Registers /sw.js (public/sw.js) so the app is installable and shows an offline
// page instead of the browser's dinosaur. Production only — a service worker in
// `npm start` caches stale bundles and makes dev confusing.
//
// The worker never caches API responses (see the header of public/sw.js), so
// there is nothing to clear on logout.

export function registerServiceWorker() {
  if (process.env.NODE_ENV !== 'production') return;
  if (!('serviceWorker' in navigator)) return;

  // After load, so registration never competes with the first render.
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((e) => {
      console.warn('[Previu] service worker registration failed:', e.message);
    });
  });
}
